import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ENDPOINTS } from '../constants/app-values';
import { AppStorage } from './appStorage.service';

@Injectable({
  providedIn: 'root'
})
export class ApiProcesosService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  getProcesos() {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });
    return this.httpClient
      .get(`${ENDPOINTS.HOST}/proceso/`, { headers: headers })
      .toPromise();
  }

  getProcesoMes(anno, mes, proceso) {

    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/proceso/auxiliar/existe`, body, {
        headers: headers
      })
      .toPromise();
  }

  cerrarAbrirProceso(anno, mes, proceso, abrirCerrar) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: mes
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/proceso/auxiliar/estado/${abrirCerrar}`, body, {
        headers: headers
      })
      .toPromise();
  }

  getProcesosActivos() {

    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });
    return this.httpClient
      .get(`${ENDPOINTS.HOST}/proceso/estado/1`, { headers: headers })
      .toPromise();
  }

  getProcesosActivosPublico() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient
      .get(`${ENDPOINTS.HOST}/publico/procesos/`, { headers: headers })
      .toPromise();
  }

  guardarProceso(proceso, departamento) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      sigla: proceso.sigla,
      nombre: proceso.nombre,
      diaHabilEmpresa: proceso.diaHabilEmpresa,
      diaMaximoEmpresa: proceso.diaMaximoEmpresa,
      diaHabilCoordinador: proceso.diaHabilCoordinador,
      diaMaximoCoordinador: proceso.diaMaximoCoordinador,
      diaHabilCierreProceso: proceso.diaHabilCierreProceso,
      diaMaximoCierreProceso: proceso.diaMaximoCierreProceso,
      habilitado: proceso.habilitado,
      email: proceso.email
    };

    return this.httpClient
      .post(
        `${ENDPOINTS.HOST}/proceso/departamento/${departamento.idDepartamento}`,
        body,
        { headers: headers }
      )
      .toPromise();
  }

  editarProceso(proceso, departamento) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      sigla: proceso.sigla,
      nombre: proceso.nombre,
      diaHabilEmpresa: proceso.diaHabilEmpresa,
      diaMaximoEmpresa: proceso.diaMaximoEmpresa,
      diaHabilCoordinador: proceso.diaHabilCoordinador,
      diaMaximoCoordinador: proceso.diaMaximoCoordinador,
      diaHabilCierreProceso: proceso.diaHabilCierreProceso,
      diaMaximoCierreProceso: proceso.diaMaximoCierreProceso,
      habilitado: proceso.habilitado,
      email: proceso.email
    };

    return this.httpClient
      .post(
        `${ENDPOINTS.HOST}/proceso/${proceso.idProceso}/departamento/${
          departamento.idDepartamento
        }`,
        body,
        { headers: headers }
      )
      .toPromise();
  }
}
